import Grid from '@ui/Grid';
import Typography from '@ui/Typography';
import { Children, FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { recapGridContainerStyle, recapGridContainerFormFlowStyle } from './styles';
import { IFormFieldRecapContainerWithTitleComponentProperties } from './types';

const isEmpty = (children : ReactNode) => Children.toArray(children).length === 0;

const FormFieldRecapContainerWithTitle: FC<IFormFieldRecapContainerWithTitleComponentProperties> = ({
    title,
    children,
    showTitle,
}) => (

    (!isEmpty(children)
        ? (
            <>
                {!showTitle && (
                    <Typography variant="body1" variantMapping={{ body1: 'h3' }} color="primary">
                        <FormattedMessage id={title} />
                    </Typography>
                )}

                <Grid
                    container
                    spacing={1}
                    direction="row"
                    justify="flex-start"
                    alignItems="stretch"
                    style={!showTitle ? recapGridContainerStyle : recapGridContainerFormFlowStyle}
                >
                    {children}
                </Grid>
            </>
        )
        : (null)));

export default FormFieldRecapContainerWithTitle;
